var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.review && _vm.review.id)?_c('StaffProductReviewCard',{staticClass:"-mx-4 border-b border-Black10 py-8 pl-1 pr-4 md:mx-0 md:px-0",attrs:{"review":_vm.review}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }